import { render } from "./GesPubPer.vue?vue&type=template&id=bdeafb58&scoped=true"
import script from "./GesPubPer.vue?vue&type=script&lang=js"
export * from "./GesPubPer.vue?vue&type=script&lang=js"

import "./GesPubPer.vue?vue&type=style&index=0&id=bdeafb58&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bdeafb58"

export default script